import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { WORKFLOWS_API } from '../api/workflows-api'
import { WorkflowApiInterface, WorkflowInterface } from '../types/workflow-interface'

export const useWorkflowActivation = (workflow: WorkflowInterface) => {
  const { fetcher: postFetcher } = useFetch<RequestMethodsEnum.post, WorkflowApiInterface>({
    method: RequestMethodsEnum.post,
  })

  const activateWorkflow = async () => await postFetcher(`${WORKFLOWS_API}/activate/${workflow.id}`)

  const deactivateWorkflow = async () =>
    await postFetcher(`${WORKFLOWS_API}/deactivate/${workflow.id}`)

  const deactivateWorkflowWithStop = async () =>
    await postFetcher(`${WORKFLOWS_API}/deactivate-with-stop-tasks/${workflow.id}`)

  return { activateWorkflow, deactivateWorkflow, deactivateWorkflowWithStop }
}
